import keyStore, { languageKey } from 'Store/keyStore';
import { currentLocale, changeLocale } from 'Lang/index';

const state = {
    isBusy: false,
    notification: {},
    confirm: {},
    layoutConfig: {},
    locale: '',
    qrcode: false,
    qrcode_result: '',
}

const getters = {
    [keyStore.ISBUSY]: (state: any) => {
        return state.isBusy || false;
    },
    [languageKey.LOCALE]: (state: any) => {
        if (!!state.locale) return state.locale;
        return currentLocale();
    },
    [keyStore.NOTIFICATION]: (state: any) => {
        const notification = state.notification;
        state.notification = {};
        return notification;
    },
    [keyStore.CONFIRM]: (state: any) => {
        const confirm = state.confirm;
        state.confirm = {};
        return confirm;
    },
    [keyStore.QRCODE]: (state: any) => {
        return state.qrcode || false;
    },
    [keyStore.QRCODE_RESULT]: (state: any) => {
        const result = state.qrcode_result;
        return result;
    }
}

const mutations = {
    [languageKey.LOCALE]: (state: any, lang: string) => {
        let langNeedToChange = changeLocale(lang);
        state.locale = langNeedToChange;
    },
    [keyStore.ISBUSY]: (state: any, isBusy: boolean) => {
        state.isBusy = isBusy;
    },
    [keyStore.NOTIFICATION]: (state: any, notification: any) => {
        state.notification = notification;
    },
    [keyStore.CONFIRM]: (state: any, confirm: any) => {
        state.confirm = confirm;
    },
    [keyStore.QRCODE]: (state: any, qrcode: boolean) => {
        state.qrcode = qrcode;
    },
    [keyStore.QRCODE_RESULT]: (state: any, result: boolean) => {
        state.qrcode_result = result;
        state.qrcode = false;
    }
}

const actions = {

}

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

